module.exports = __webpack_public_path__ + "img/PILOTAGE.32794aa9.svg";